export const FEATURE_SWITCHES = {
   DISABLE_RECAPTCHA: 'disable_recaptcha',
   SUNSET_BANNER: 'sunset_banner'
}
